export type ShootScheduleStatusRow = {
  id: string
  insertDate: string
  staff: string
  scheduleDate: string
  scheduleTime: string
  product: string
  state: string
  packageName: string
  baby: string
  parent: string
  phone: string
  customerType: string
  visitRoute: string
}

// 비식별 화면 전용 Mock: 운영 고객·직원·계약 데이터와 연결하지 않는다.
export const legacyShootScheduleStatusRows: ShootScheduleStatusRow[] = [
  {
    id: 'mock-shoot-01', insertDate: '2026-08-20', staff: 'Mock 등록자 01',
    scheduleDate: '2026-08-23', scheduleTime: '10:00', product: 'Mock 촬영 항목 A',
    state: '예정', packageName: 'Mock 패키지 A', baby: 'Mock 아기 A',
    parent: 'Mock 보호자 A', phone: '010-0000-0001', customerType: '신규', visitRoute: 'Mock 유입 A',
  },
  {
    id: 'mock-shoot-02', insertDate: '2026-08-19', staff: 'Mock 등록자 02',
    scheduleDate: '2026-08-25', scheduleTime: '14:30', product: 'Mock 촬영 항목 B',
    state: '확정', packageName: 'Mock 패키지 B', baby: 'Mock 아기 B',
    parent: 'Mock 보호자 B', phone: '010-0000-0002', customerType: '기존', visitRoute: 'Mock 유입 B',
  },
]

export const legacyShootScheduleStatistics = {
  customerType: [['신규', 1], ['기존', 1]],
  visitRoute: [['Mock 유입 A', 1], ['Mock 유입 B', 1]],
  product: [['Mock 촬영 항목 A', 1], ['Mock 촬영 항목 B', 1]],
  staff: [['Mock 등록자 01', 1], ['Mock 등록자 02', 1]],
} as const
